import React from 'react';
import '../styles/syberkey-brand.css';

/**
 * Inline “SyberKey” text — white “Syber” + gold “Key” (default). Use variant="onLight" only on
 * white cards where dark slate “Syber” is intentional; prefer a dark card + default wordmark.
 * @param {object} props
 * @param {string} [props.className]
 * @param {'onLight'|undefined} [props.variant]
 */
function SyberKeyWordmark({ className = '', variant }) {
  const v = variant === 'onLight' ? 'syberkey-mark--on-light' : '';
  return (
    <span className={`syberkey-mark ${v} ${className}`.trim()}>
      <span className="syberkey-mark__syber">Syber</span>
      <span className="syberkey-mark__key">Key</span>
    </span>
  );
}

export default SyberKeyWordmark;
